// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";
//List all Orders
export const viewDonate = createAsyncThunk("donate", async (thunkAPI) => {
  try {
    let response = await axios.get(`${BaseUrl}backend-api/donate`);
    if (response.status === 200) {
      return response.data;
    } else {
      handleError(response.message);
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    handleError("loading...");
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

//Add new Order
export const registerDonate = createAsyncThunk(
  "donate",
  async (sentData, thunkAPI) => {
    try {
      let URL = `${BaseUrl}backend-api/chapaDonate`;
      let response = await axios.post(URL, sentData);
      //condition
      if (response.status === 200) {
        //handleSuccess("Register successfull!");
        return response.data;
      } else {
        handleError(response.data.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
